import React from 'react';
import './AddButton.css';

const AddButton = ({ onClick, children, icon }) => {
  return (
    <button className="add-btn" onClick={onClick}>
      {icon && <i className={icon}></i>}
      {children}
    </button>
  );
};

export default AddButton;